export const recaptcha = firebase.auth.RecaptchaVerifier;
export const auth = firebase.auth();
export const db = firebase.firestore();
export const timestamp = firebase.firestore.Timestamp;
export const PROVIDER_ID = firebase.auth.PhoneAuthProvider.PROVIDER_ID;
